class FabricSwatches extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      button: "[data-button]",
      buttonCount: "[data-selected-count]",
      checkboxes: 'input[type="checkbox"]'
    };
    this.button = null;
    this.checkboxes = [];
    this.limit = Number(this.getAttribute("data-limit")) || 0;
    this.boundHandleClick = this.handleClick.bind(this);
    this.boundHandleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.cacheDOMElements();
    this.toggleEventListeners();
    this.syncSelectionState();
  }

  disconnectedCallback() {
    this.toggleEventListeners(true);
  }

  toggleEventListeners(shouldRemove = false) {
    const method = shouldRemove ? "removeEventListener" : "addEventListener";
    this[method]("click", this.boundHandleClick, true);
    this[method]("change", this.boundHandleChange);
  }

  handleClick(event) {
    if (this.limit <= 0) {
      return;
    }

    const target = event.target instanceof Element ? event.target : null;
    const label = target?.closest('label[for]');
    const labelFor = label?.getAttribute("for");
    const clickedCheckbox = label
      ? this.ownerDocument.getElementById(labelFor || "")
      : target instanceof HTMLInputElement && target.type === "checkbox"
        ? target
        : null;

    if (!(clickedCheckbox instanceof HTMLInputElement) || clickedCheckbox.checked) {
      return;
    }

    if (this.getSelectedCount() >= this.limit) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  handleChange(event) {
    const changedCheckbox = event.target instanceof HTMLInputElement ? event.target : null;

    if (changedCheckbox?.type === "checkbox" && changedCheckbox.checked && this.limit > 0) {
      const selectedCount = this.getSelectedCount();

      if (selectedCount > this.limit) {
        changedCheckbox.checked = false;
      }
    }

    this.syncSelectionState();
  }

  getSelectedCount() {
    return this.checkboxes.filter((checkbox) => checkbox.checked).length;
  }

  syncSelectionState() {
    const selectedCount = this.getSelectedCount();
    const hasReachedLimit = this.limit > 0 && selectedCount >= this.limit;

    this.button.disabled = selectedCount === 0 || (this.limit > 0 && selectedCount > this.limit);

    this.checkboxes.forEach((checkbox) => {
      checkbox.disabled = hasReachedLimit && !checkbox.checked;
    });

    const buttonCount = this.button.querySelector(this.selectors.buttonCount);
    if (buttonCount) {
      buttonCount.textContent = selectedCount.toString();
    }
  }

  cacheDOMElements() {
    const button = this.querySelector(this.selectors.button);
    if (!button) {
      throw new Error("Button element not found");
    }
    this.button = button;

    const checkboxes = Array.from(this.querySelectorAll(this.selectors.checkboxes));
    if (!checkboxes.length) {
      throw new Error("Checkboxes not found");
    }
    this.checkboxes = checkboxes;
  }
}

customElements.define("fabric-swatches", FabricSwatches);
